import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=982e5c40&scoped=true&"
import script from "./FaqPage.vue?vue&type=script&lang=js&"
export * from "./FaqPage.vue?vue&type=script&lang=js&"
import style0 from "./FaqPage.vue?vue&type=style&index=0&id=982e5c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982e5c40",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/faq_page.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Ffaq%2FFaqPage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports